// extracted by mini-css-extract-plugin
export default {"addButton":"AddDivision_addButton__39O5P","dialog":"AddDivision_dialog__Xp1Oq","dialogContent":"AddDivision_dialogContent__L3RWK","dialogFooter":"AddDivision_dialogFooter__8JKt9"};